// 计算字符re在S中出现的次数
export function count(re, s) {
  re = eval("/" + re + "/ig")
  if (s.match(re)) {
    return s.match(re).length
  } else {
    return 0;
  }
}

// 排序
export function arraySort(keyName) {
  return function (objectN, objectM) {
    var valueN = objectN[keyName]
    var valueM = objectM[keyName]
    if (valueN > valueM) return 1
    else if (valueN < valueM) return -1
    else return 0
  }
}